import CryptoJS from "crypto-js";

const secretKey = CryptoJS.enc.Base64.parse(process.env.REACT_APP_CRYPTO_SECRET);
const iv = CryptoJS.enc.Utf8.parse("1234567890123456");

/**
 * 데이터가 암호화되어 있는지 확인하는 함수
 * Base64 형식이고 복호화가 가능하면 암호화된 것으로 판단
 */
const isEncrypted = (data) => {
    if (!data || typeof data !== 'string') {
        return false;
    }

    const trimmedData = data.trim();

    // Base64 패턴 체크 (AES 암호화 결과는 Base64 형식)
    const base64Pattern = /^[A-Za-z0-9+/]+=*$/;
    if (!base64Pattern.test(trimmedData)) {
        return false;
    }

    // 길이가 너무 짧으면 평문일 가능성이 높음
    if (trimmedData.length < 20) {
        return false;
    }

    // 실제 복호화 시도 (조용히 실패 처리)
    try {
        const bytes = CryptoJS.AES.decrypt(trimmedData, secretKey, {
            iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        const decrypted = bytes.toString(CryptoJS.enc.Utf8);

        // 복호화 결과가 유효하면 암호화된 데이터로 판단
        return decrypted && decrypted.trim() !== '';
    } catch {
        return false;
    }
};

// 암호화 (AES)
export const encryptData = (data) => {
    try {
        // null, undefined, 빈 문자열 체크
        if (data === null || data === undefined || data === '') {
            return null;
        }

        // 이미 암호화된 데이터인지 확인
        if (typeof data === 'string' && isEncrypted(data)) {
            return data; // 이미 암호화되어 있으면 그대로 반환
        }

        const cipherText = CryptoJS.AES.encrypt(
            JSON.stringify(data),
            secretKey,
            { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
        ).toString();

        return cipherText;
    } catch (error) {
        console.error('Encryption error:', error);
        return null;
    }
};

// 복호화 (AES) - 안전한 버전
export const decryptData = (cipherText) => {
    // 입력 검증
    if (!cipherText || typeof cipherText !== 'string' || cipherText.trim() === '') {
        return null;
    }

    // 암호화되지 않은 평문 데이터인 경우 그대로 반환
    if (!isEncrypted(cipherText)) {
        return cipherText; // 평문 그대로 반환
    }

    // 암호화된 데이터 복호화 (isEncrypted에서 이미 검증됨)
    try {
        const bytes = CryptoJS.AES.decrypt(
            cipherText.trim(),
            secretKey,
            { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
        );

        const decrypted = bytes.toString(CryptoJS.enc.Utf8);

        // 복호화 결과 검증
        if (!decrypted || decrypted.trim() === '') {
            // isEncrypted()를 통과했는데 여기서 실패하는 경우는 드물지만
            // 발생 시 원본 반환 (경고 없이)
            return cipherText;
        }

        // JSON 파싱 시도
        try {
            const jsonParse = JSON.parse(decrypted)
            return typeof jsonParse === 'number' ? String(jsonParse) : jsonParse
        } catch (parseError) {
            // JSON이 아닌 경우 문자열 자체를 반환
            return decrypted;
        }

    } catch (error) {
        // 오류 발생 시 원본 반환 (기존 평문 데이터 보호)
        return cipherText;
    }
};